import { useQuery } from '@tanstack/react-query';
import { useAPIErrorHandler } from '../../useAPIErrorHandler';
import { queries } from '../../../../queries';

export const useFetchSubmissionStatusOptions = () => {
  const handleAPIError = useAPIErrorHandler();

  return useQuery({
    ...queries.submissions.statuses(),
    keepPreviousData: true,
    onError: handleAPIError('Unable to fetch Submissions Statuses'),
    cacheTime: Infinity,
    staleTime: 3600000, //1 hour stale time
  });
};
